<div class="math-ext-link-activity-container" fxLayout="column"
  fxLayoutAlign="center center"
  fxFlex="100">
  <div class="math-displayName">
    {{asset?.displayName}}
  </div>

  <div class="math-directions">
    Download the {{fileFormat}} using the button below. Then when you’ve completed your work, mark this assignment as submitted.
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxFlex="100"
    fxLayoutGap="5px"
    >
    <div>
      <button
        mat-raised-button
        class="formatOption"
        (click)="launchLink(asset)"
        >
        {{fileFormat}} <mat-icon>save_alt</mat-icon>
      </button>
    </div>

    @if (!assignment?.completedAt) {
      <div>
        <button
          type="button"
          mat-raised-button
          color="primary"
          [disabled]="!isDownloaded"
          (click)="markAsSubmitted()"
          >
          Mark as Submitted
        </button>
      </div>
    }
    @if (assignment?.completedAt) {
      <div>
        <button
          type="button"
          mat-raised-button
          color="primary"
          [disabled]="true"
          >
          Already Submitted <mat-icon class="math-submitted-icon">check</mat-icon>
        </button>
      </div>
    }
  </div>
</div>


